// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dna_wrapper___8M0X","borderWrap":"dna_borderWrap__AZvUc","grid":"dna_grid__UDyei","image":"dna_image__J8pJ7"};